export default __webpack_public_path__ + "static/media/natalia2.6dcff816.jpg";